export function getLastDay(y, m) {
	const d = new Date(y, m, 0).getDate();
	return d;
}
